import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Renderer2,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { GeneralService } from '../../../../services/general/general.service';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['../../../../../shared-styles/settings.scss'],
})
export class CertificatesComponent implements OnInit, OnDestroy {
  public loading: any = false;
  public sending: any = false;
  public subscriptions: any = [];
  public form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService
  ) {
    this.form = this.formBuilder.group({
      certificates: this.formBuilder.array([]),
    });
  }

  async ngOnInit() {
    try {
      document.addEventListener('set-lang', this);
      this.intializeSubscriptions();
      await this.loadData();
    } catch (error: any) {
      await this.general.showDanger(error.message);
    }
  }

  async loadData() {
    try {
      this.general.setLoading(true);
      this.certificatesFormArray.clear();

      const response: any = await this.general.httpGet(
        'teacher-profile-certificates-data'
      );
      response.data.certificates.forEach((certificate: any) => {
        let substrings = certificate.document_path.split('.');
        console.log();

        this.certificatesFormArray.push(
          this.formBuilder.group(
            {
              type: [certificate.type, [Validators.required]],
              issued_by: [certificate.issued_by, [Validators.required]],
              study_years: [certificate.study_years, [Validators.required]],
              document_base64: [''],
              document: [''],
              type_doc: [substrings[substrings.length - 1]],
              document_path: [certificate.document_path],
              id: [certificate.id],
              state: [certificate.status],
              id_image: [this.general.getRandomId(5)],
            },
            {
              validators: [this.checkImage(), this.validateStudyYears()],
            }
          )
        );
      });
    } catch (error: any) {
      await this.general.showDanger(error.message);
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });

    document.removeEventListener('set-lang', this);
  }

  // Handle event Listener
  async handleEvent(event: any) {
    switch (event.type) {
      case 'set-lang':
        await this.loadData();
        break;
    }
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  /**
   * =================== Form ===================
   */
  get validateForm() {
    return this.form.valid;
  }
  async sendForm() {
    try {
      this.sending = true;
      const formData: FormData = new FormData();
      let certificates: any = [];
      this.form.value.certificates.forEach((certificate: any) => {
        let res = { ...certificate };
        delete res.document_path;
        if (!res.document_base64) {
          delete res.document_base64;
        }
        certificates.push(res);
      });
      console.log(certificates);
      formData.append('certificates', JSON.stringify(certificates));

      const response = await this.general.httpPost(
        'upd-teacher-profile-certificates-data',
        formData
      );
      await this.general.showSuccess('data-saved-successfully');
    } catch (error) {
      await this.general.showErrorForm(error);
      console.log(error);
    } finally {
      this.sending = false;
    }
  }

  get certificatesFormArray(): any {
    return this.form.get('certificates') as FormArray;
  }

  addCertificate(): void {
    this.certificatesFormArray.push(
      this.formBuilder.group(
        {
          type: ['', [Validators.required]],
          issued_by: ['', [Validators.required]],
          study_years: ['', [Validators.required]],
          document_base64: [''],
          document: [''],
          document_path: [''],
          id_image: [this.general.getRandomId(5)],
        },
        {
          validators: [this.checkImage(), this.validateStudyYears()],
        }
      )
    );
  }

  removeCertificate(index: any): void {
    this.certificatesFormArray.removeAt(index);
  }

  onSelectCertificate(event: any, index: any, idImage: any) {
    if (event.files.item(0)) {
      const file = event.files.item(0);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const body: any = {};
        body['document_base64'] = reader.result;
        body['document'] = file;

        this.certificatesFormArray.controls[index].patchValue(body);
        if (file.type.includes('image/')) {
          setTimeout(() => {
            const $source: any = document.getElementById(
              'certificate-' + idImage
            );
            $source.setAttribute(
              'src',
              this.certificatesFormArray.controls[index].value.document_base64
            );
          }, 200);
        }
      };
    }
  }

  checkImage() {
    return (formGroup: FormGroup) => {
      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const baseControl = formGroup.controls['document_base64'];
      const pathControl = formGroup.controls['document_path'];

      if (!pathControl.value && !baseControl.value) {
        baseControl.setErrors({ badPasswords: true });
      }
    };
  }

  validateStudyYears() {
    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const yearsControl = formGroup.controls['study_years'];

      if (
        !yearsControl.value ||
        !/^[1-9]\d{3}-[1-9]\d{3}$/g.test(yearsControl.value)
      ) {
        res = { badregx: true };
        yearsControl.setErrors(res);
        return;
      }
      if (
        parseInt(yearsControl.value.split('-')[0]) > new Date().getFullYear() ||
        parseInt(yearsControl.value.split('-')[1]) > new Date().getFullYear() ||
        parseInt(yearsControl.value.split('-')[0]) >
          parseInt(yearsControl.value.split('-')[1])
      ) {
        res = { bad: true };
        yearsControl.setErrors(res);
        return;
      }

      yearsControl.setErrors(res);
    };
  }

  downloadFile(url: any) {
    window.open(url, '_blank');
  }
}
